// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React from 'react';
import cn from 'classnames';
import {Text} from '@pub/comp/text';
import './form.less';

export function Item({
    children,
    title,
    hint,
    required,
    className,
    is_div,
    is_hidden,
})
{
    const Tag = is_div ? 'div' : 'label';
    const classes = cn('sdk-form-item',
        is_hidden&&'sdk-form-item__hidden', className);
    return <Tag className={classes}>
      {title
        ? <Text.s>
          {title}
          {required ? <Text.s span error>{' *'}</Text.s> : null}
        </Text.s>
        : null}
      {!!hint&&<Text.xxs tertiary>{hint}</Text.xxs>}
      <div className="sfi-input">{children}</div>
    </Tag>;
}

export function Items_row({children, className}){
    return <div className={cn('sdk-form-items-row', className)}>
      {children}
    </div>;
}
